'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NewMediumGzh = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(NewMediumGzh, _Component);

  function NewMediumGzh() {
    (0, _classCallCheck3.default)(this, NewMediumGzh);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(NewMediumGzh).call(this));
  }

  (0, _createClass3.default)(NewMediumGzh, [{
    key: 'render',
    value: function render() {
      var datas = [{
        'img1': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg10.jpg',
        'img2': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg12.jpg',
        'fansNum': '936500',
        'title': '十点读书',
        'content': '深夜试点，陪你读书',
        'qc': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg11.jpg'
      }, {
        'img1': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg10.jpg',
        'img2': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg12.jpg',
        'fansNum': '936500',
        'title': '十点读书',
        'content': '深夜试点，陪你读书',
        'qc': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg11.jpg'
      }, {
        'img1': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg10.jpg',
        'img2': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg12.jpg',
        'fansNum': '936500',
        'title': '十点读书',
        'content': '深夜试点，陪你读书',
        'qc': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg11.jpg'
      }, {
        'img1': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg10.jpg',
        'img2': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg12.jpg',
        'fansNum': '936500',
        'title': '十点读书',
        'content': '深夜试点，陪你读书',
        'qc': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg11.jpg'
      }, {
        'img1': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg10.jpg',
        'img2': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg12.jpg',
        'fansNum': '936500',
        'title': '十点读书',
        'content': '深夜试点，陪你读书',
        'qc': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg11.jpg'
      }, {
        'img1': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg10.jpg',
        'img2': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg12.jpg',
        'fansNum': '936500',
        'title': '十点读书',
        'content': '深夜试点，陪你读书',
        'qc': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg11.jpg'
      }, {
        'img1': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg10.jpg',
        'img2': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg12.jpg',
        'fansNum': '936500',
        'title': '十点读书',
        'content': '深夜试点，陪你读书',
        'qc': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg11.jpg'
      }, {
        'img1': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg10.jpg',
        'img2': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg12.jpg',
        'fansNum': '936500',
        'title': '十点读书',
        'content': '深夜试点，陪你读书',
        'qc': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg11.jpg'
      }, {
        'img1': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg10.jpg',
        'img2': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg12.jpg',
        'fansNum': '936500',
        'title': '十点读书',
        'content': '深夜试点，陪你读书',
        'qc': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg11.jpg'
      }, {
        'img1': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg10.jpg',
        'img2': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg12.jpg',
        'fansNum': '936500',
        'title': '十点读书',
        'content': '深夜试点，陪你读书',
        'qc': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg11.jpg'
      }, {
        'img1': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg10.jpg',
        'img2': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg12.jpg',
        'fansNum': '936500',
        'title': '十点读书',
        'content': '深夜试点，陪你读书',
        'qc': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg11.jpg'
      }, {
        'img1': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg10.jpg',
        'img2': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg12.jpg',
        'fansNum': '936500',
        'title': '十点读书',
        'content': '深夜试点，陪你读书',
        'qc': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg11.jpg'
      }, {
        'img1': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg10.jpg',
        'img2': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg12.jpg',
        'fansNum': '936500',
        'title': '十点读书',
        'content': '深夜试点，陪你读书',
        'qc': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg11.jpg'
      }, {
        'img1': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg10.jpg',
        'img2': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg12.jpg',
        'fansNum': '936500',
        'title': '十点读书',
        'content': '深夜试点，陪你读书',
        'qc': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg11.jpg'
      }, {
        'img1': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg10.jpg',
        'img2': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg12.jpg',
        'fansNum': '936500',
        'title': '十点读书',
        'content': '深夜试点，陪你读书',
        'qc': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg11.jpg'
      }, {
        'img1': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg10.jpg',
        'img2': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg12.jpg',
        'fansNum': '936500',
        'title': '十点读书',
        'content': '深夜试点，陪你读书',
        'qc': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg11.jpg'
      }, {
        'img1': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg10.jpg',
        'img2': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg12.jpg',
        'fansNum': '936500',
        'title': '十点读书',
        'content': '深夜试点，陪你读书',
        'qc': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg11.jpg'
      }];
      var styles = require('./NewMediumGzh.scss');
      return _react2.default.createElement(
        'ul',
        { className: styles.new_right_wx },
        datas instanceof Array && datas.length > 0 ? datas.map(function (item, index) {
          return _react2.default.createElement(_components.NewMediumGzhComponent, { key: index, index: index, data: item });
        }) : ''
      );
    }
  }]);
  return NewMediumGzh;
}(_react.Component), _class.propTypes = {
  filterData: _react.PropTypes.object
}, _temp);
exports.default = NewMediumGzh;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/NewMediumGzh/NewMediumGzh.js
 ** module id = 1504
 ** module chunks = 0
 **/